const template = require('./index.html')
const browserEvent = require('@isoftdata/browser-event')

module.exports = function createModalComponent() {
	// eslint-disable-next-line no-undef
	return Ractive.extend({
		template,
		isolated: true,
		transitions: {
			fade: require('ractive-transitions-fade'),
			fly: require('ractive-transitions-fly'),
		},
		data() {
			return {
				show: false,
				modalId: "itModal",
				modalTitle: "Confirm",
				modalSubtitle: '',
				closeShown: true,
				cancelShown: true,
				confirmShown: true,
				cancelButtonText: "Close",
				cancelButtonBootstrapClass: "secondary",
				cancelButtonFontAwesomeIcon: "times",
				confirmButtonText: "Confirm",
				confirmButtonType: "button",
				confirmButtonFormId: "",
				confirmButtonBootstrapClass: "success",
				confirmButtonFontAwesomeIcon: "check",
				confirmButtonDisabled: false,
				bootstrapModalSizeClass: "",
				backdropClickCancels: false,
				transitionMode: "present",
				showModalContent: true,
				savingInProgress: false,
				zIndex: 20000,
				headerShown: true,
				footerShown: true,
				modalDialogClass: '',
				modalBodyClass: '',
			}
		},
		oninit() {
			const ractive = this

			ractive.on('backdrop', e => {
				const path = e?.original?.composedPath()
				if (path) {
					const matches = path
						.filter(el => {
							return el.className &&
								el.className.indexOf('modal-content') > -1
						})

					if (!matches.length) {
						ractive.set({ show: false })
					}
				}
			})

			ractive.observe('show', shown => {
				const el = document.getElementsByTagName('body')[0]
				let removeEscKeyListener

				if (shown) {
					el.classList.add('modal-open')
					removeEscKeyListener = browserEvent(el, 'keydown', event => {
						if (event.code === 'Escape') {
							ractive.set('show', false)
						}
					})
				} else {
					if (removeEscKeyListener) {
						removeEscKeyListener()
					}
					el.classList.remove('modal-open')
				}
			})

			ractive.observe('show', shown => {
				if (shown) {
					const el = ractive.find(`#${ractive.get('modalId')}`)
					if (el) {
						el.focus()
					}
				}
			}, { init: false, defer: true })
		},
	})
}
